export default "__VITE_ASSET__D_9EaBFQ__"